import React from 'react';

import Card from 'components/DesignSystem/Card';
import SubtitleSemiBold from 'components/Typography/SubtitleSemiBold';
import RelatorioTable from 'components/Relatorios/shared/RelatorioTable';
import PrecosTable from 'components/Relatorios/Dessem/secoes/Resultados/PrecosTable';
import BalancoChart from 'components/Relatorios/Dessem/secoes/Resultados/BalancoChart';
import SecaoDessemEstado from 'components/Relatorios/Dessem/secoes/shared/SecaoDessemEstado';
import GraficoTelaCheia from 'components/Relatorios/shared/Mobile/GraficoTelaCheia';

import useDessemSecaoParams from 'hooks/Relatorios/Dessem/useDessemSecaoParams';
import { useGetDessemResultadosQuery } from 'services/api/products/relatorios';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Resultados() {
  const params = useDessemSecaoParams();
  const isMobile = useIsMobile();

  const resultado = useGetDessemResultadosQuery(params);

  return (
    <SecaoDessemEstado resultado={resultado} params={params}>
      {({
        titulo, precos, balanco, intercambio,
      }) => (
        // Títulos do payload desde 15/10/2026 (contrato §2.14); sem eles (BE antigo), os de antes.
        <Card title={titulo ?? 'Resultados'}>
          {/* Mobile: o título "Preços" vai para o cabeçalho do botão de tela cheia (a tabela é
              larga — 1 + contingências × limites × subsistemas colunas). */}
          {!isMobile && <SubtitleSemiBold>{precos.titulo ?? 'Preços'}</SubtitleSemiBold>}
          <GraficoTelaCheia titulo={precos.titulo ?? 'Preços'}>
            {() => <PrecosTable precos={precos} />}
          </GraficoTelaCheia>

          <BalancoChart colunas={balanco.colunas} linhas={balanco.linhas} titulo={balanco.titulo} />

          <div className="mt-5">
            <SubtitleSemiBold>{intercambio.titulo ?? 'Fluxos de Intercâmbio'}</SubtitleSemiBold>
          </div>
          <RelatorioTable
            semCard
            columns={['Origem', 'Destino', 'MWm']}
            rows={intercambio.linhas.map((linha) => [linha.origem, linha.destino, linha.valor])}
          />
        </Card>
      )}
    </SecaoDessemEstado>
  );
}
